import { render, staticRenderFns } from "./ShareGoods.vue?vue&type=template&id=8ba6014c&"
import script from "./ShareGoods.vue?vue&type=script&lang=js&"
export * from "./ShareGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports